const $ = App.common.jQuery

class RightNowSurvey {
   static init(form) {
      form = $(form)
      form.find('.show-condition').each(function(i) {
         var area = $(this)
         var condition = area.data('require').match(/^\s*([\w_]+)\s*=\s*(.*?)\s*$/)
         // area.css({display:'block', height: '0px'})
         area.addClass('collapse')
         var handler = function() {
            var field = $(this)
            if (field.val() == condition[2]) {
               area.collapse('show')
               // Only "hide" if shown - otherwise it'll show it >_<
            }
            else if (area.hasClass('show')) {
               area.collapse('hide')
            }
         }
         form.find(':input[name="'+condition[1]+'"]').each(function(i) {
            $(this).change(handler)
         })
      })


      // form.validator({disable: false}).on('submit', function (e) {
      form.on('submit', function (e) {
            if (e.isDefaultPrevented()) {
         } else {
            RightNowSurvey.submit(form)
            e.preventDefault()
            return false;
         }
      })
   }

   static submit(form) {
      var data = $(form).serialize()
      var context = $('form.rightnow-context').serialize()
      $('#submit_btn').val('Please Wait')
      $('.feedback-form').addClass('feedback-submitting')
      $.ajax({
         type: 'POST',
         url: BaseURL+'/survey/',
         data: {data: data, context: context, action: $(form).attr('action')},
         success: function (data, status, xhr) {
            if (data && data.status) {
               if (data.status == 'ok') {
                  $('div.feedback-form').collapse('hide')
                  $('div.feedback-done').collapse('show')
               }
               else {
                  $('div.feedback-alert').html(data.message||'There was a problem submitting your feedback. Please check your answers and try again.')
                  $('div.feedback-alert').collapse('show')
                  $('html,body').animate({
                     scrollTop: $('div.feedback-alert').offset().top
                  },500)
               }
            } else {
               $('div.feedback-form').collapse('hide')
               $('div.feedback-error').collapse('show')
            }
            // console.log('Success', data, status)
         },
         error: function(xhr, status, err) {
            $('div.feedback-form').collapse('hide')
            $('div.feedback-error').collapse('show')
         },
         complete: function(xhr, status) {
            $('#submit_btn').val('Send Feedback')
            $('.feedback-form').removeClass('feedback-submitting')
         }
      })
      return false;
   }
}

module.exports = RightNowSurvey
